import { useEffect, useState } from "react";
import { Panel } from "@/components/Panel";

export default function KeywordsPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [edit, setEdit] = useState<Record<string, string>>({});
  const [msg, setMsg] = useState("");
  const [scopes, setScopes] = useState<any[]>([]);
  async function load() {
    const r = await fetch("/api/v1/subjects/aliases");
    if (r.status === 401) { location.href = "/login"; return; }
    const j = await r.json();
    setRows(j.data ?? []);
    setEdit(Object.fromEntries((j.data ?? []).map((s: any) => [s.id, (Array.isArray(s.aliases) ? s.aliases : []).join(", ")])));
  }
  useEffect(() => {
    fetch("/api/v1/subjects/scopes").then((r) => (r.ok ? r.json() : { data: [] })).then((j) => setScopes(j.data ?? [])); load(); }, []);
  async function save(id: string) {
    setMsg("menyimpan...");
    const aliases = (edit[id] ?? "").split(",").map((x) => x.trim()).filter(Boolean);
    const r = await fetch("/api/v1/subjects/aliases", { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ subjectId: id, aliases }) });
    const j = await r.json();
    setMsg(r.ok ? `Tersimpan (${j.count} sinonim). Muat ulang halaman lain agar highlight terbarui.` : j.error ?? "gagal");
  }
  return (
    <div className="avio-rise">
      <div>
        <h1 className="avio-page-title" style={{ margin: 0 }}>Keyword & Sinonim</h1>
        <div className="avio-t-sm avio-muted">
          Nama subjek dan nama kategori otomatis di-highlight di daftar artikel. Tambahkan sinonim (pisahkan koma), mis. Kementerian Hukum, Menkumham, AHU Online. Minimal 3 huruf.
        </div>
      </div>

      {msg && <div className="avio-banner" data-tone="info"><i className="fa-solid fa-circle-info avio-banner__icon" /><div>{msg}</div></div>}

      <div className="avio-grid">
        {rows.map((s2) => (
          <div key={s2.id} data-col="6">
            <Panel icon="fa-solid fa-highlighter" title={s2.name} hint="sinonim highlight">
              <textarea className="avio-input" value={edit[s2.id] ?? ""} onChange={(e) => setEdit((p2) => ({ ...p2, [s2.id]: e.target.value }))}
                rows={3} style={{ width: "100%", fontFamily: "inherit", fontSize: "var(--text-md)" }} placeholder="sinonim1, sinonim dua, ..." />
              <div style={{ marginTop: "var(--space-5)", display: "flex", justifyContent: "flex-end" }}>
                <button className="avio-btn" data-variant="primary" data-size="sm" onClick={() => save(s2.id)}>
                  <i className="fa-solid fa-floppy-disk" /> Simpan
                </button>
              </div>
            </Panel>
          </div>
        ))}
        {rows.length === 0 && (
          <div data-col="12">
            <Panel icon="fa-solid fa-highlighter" title="Subjek pantauan">
              <div className="avio-empty"><i className="fa-regular fa-face-meh avio-empty__icon" /><div className="avio-empty__title">Belum ada subjek pantauan.</div></div>
            </Panel>
          </div>
        )}

        <div data-col="12">
          <Panel icon="fa-solid fa-link" title="Scope vendor" hint="ikatan subjek → kategori Digivla / keyword Neticle">
            <div className="avio-banner" data-tone="warning" style={{ marginBottom: "var(--space-6)" }}>
              <i className="fa-solid fa-triangle-exclamation avio-banner__icon" />
              <div>
                Bila vendor mengganti nama kategori (pernah terjadi), ingestion diam-diam kosong untuk kategori itu. Selaraskan dari terminal:
                <code> pnpm scope:sync</code> untuk melihat, lalu <code> pnpm scope:sync --apply</code> untuk menerapkan. Halaman admin untuk kelola scope masih dalam antrean pengembangan.
              </div>
            </div>
            <div className="avio-list">
              {scopes.map((sub: any) => (
                <div key={sub.id} className="avio-item" style={{ paddingLeft: 0, paddingRight: 0, alignItems: "flex-start" }}>
                  <span className="avio-item__main">
                    <span className="avio-item__title">{sub.name}</span>
                    <span style={{ display: "flex", gap: "var(--space-4)", flexWrap: "wrap", marginTop: "var(--space-4)" }}>
                      {sub.scopes.map((x: any, i: number) => (
                        <span key={i} className="avio-chip" data-tone="soft">
                          <i className={x.vendor === "digivla" ? "fa-solid fa-newspaper" : "fa-solid fa-bullhorn"} />
                          <span className="avio-chip__label">{x.vendorRef}</span>
                        </span>
                      ))}
                      {sub.scopes.length === 0 && (
                        <span className="avio-chip" style={{ background: "var(--status-danger-bg)", color: "var(--status-danger)" }}>
                          <span className="avio-chip__label">tanpa scope — subjek ini tidak menarik data apa pun</span>
                        </span>
                      )}
                    </span>
                  </span>
                </div>
              ))}
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
}
